module.exports = __webpack_public_path__ + "static/media/dots-gray-icon.164375f6.svg";